import $ from '@nuskin/nuskinjquery';
import {util} from '@nuskin/ns-util';

/**
 *
 * ModalUtil
 *
 * @namespace ModalUtil
 */
const ModalUtil = function() {
    'use strict';

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {

        /**
         * toggles Modal
         * @memberof ModalUtil
         * @example
         * ModalUtil.toggleModal(options, modalContainer, modalShown)
         */
        toggleModal: function(options, modalContainer, modalShown) {
            options || (options = {});

            const $modal = modalContainer.find('.ng-modal-dialog-content .ng-scope');
            const $container = modalContainer.find('.modal');
            const $overlay = modalContainer.find('.scrim');

            // Apply options
            if (options.size) {
                $container.addClass('size-' + options.size);
            }
            if (options.id) {
                $container.attr('id', options.id);
            }
            if (options.borderless) {
                $container.addClass('borderless');
            }

            // Trigger the modal
            if (!modalShown) {
                // Prevent any events from getting past the scrim
                $overlay.on('scroll', modalPreventEvents);

                // If this is an iOS device, block out pointer-events
                // because for some reason the modal won't scroll
                const isIOS = util.MobileUtils.isIOS();
                if (isIOS && isIOS.length > 0) {
                    $modal.css('pointer-events', 'none');
                }

                $('body').addClass('modal-open');
            } else {
                $overlay.off('scroll', modalPreventEvents);
                $('body').removeClass('modal-open');
            }
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    // Prevents the background from scrolling when the user scrolls the modal
    function modalCaptureEvents(evt) {
        if (evt.stopPropagation) {
            evt.stopPropagation();
        } else {
            evt.cancelBubble();
        }
    }
    function modalPreventEvents(evt) {
        modalCaptureEvents(evt);
        evt.preventDefault();
        return false;
    }

    return publicMethods;
}();

export default ModalUtil;
